'use strict';

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result['default'] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils_1 = require('@lsg/utils');

var React = __importStar(require('react'));

var uniqid_1 = __importDefault(require('uniqid'));

var CSSPrefix_1 = require('../../../base/CSSPrefix');

var canAnimateSvg = typeof window !== 'undefined' && !!document.createElementNS && /SVGAnimate/.test(document.createElementNS('http://www.w3.org/2000/svg', 'animate').toString());

var CircleDiagram =
/** @class */
function (_super) {
  __extends(CircleDiagram, _super);

  function CircleDiagram() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      animationStarted: undefined,
      animationLabel: undefined,
      animationAmount: undefined,
      size: 0
    };
    _this.uuid = _this.props.id || uniqid_1["default"]('lsg--circlediagram-');

    _this.updateSize = function () {
      var size = _this.elementRef && _this.elementRef.clientWidth;

      _this.setState({
        size: size
      });
    };

    _this.handleVisibilityChange = function (visibleIds) {
      if (visibleIds.length > 0) {
        utils_1.WindowEvents.removeVisibilityCallback(_this.handleVisibilityChange);

        _this.animate();
      }
    };

    _this.animate = function () {
      var animationStarted = _this.state.animationStarted || Date.now();
      var animationAmount = (Date.now() - animationStarted) / 1000 / CircleDiagram.animationDuration;
      var animationLabel = _this.props.valueAnimationCallback && animationAmount < 1 ? _this.props.valueAnimationCallback(animationAmount, _this.props.amount * animationAmount) : undefined;

      _this.setState({
        animationStarted: animationStarted,
        animationLabel: animationLabel,
        animationAmount: animationAmount
      }, function () {
        if (animationAmount < 1 && window.requestAnimationFrame) {
          window.requestAnimationFrame(_this.animate);
        }
      });
    };

    return _this;
  }

  CircleDiagram.prototype.componentDidMount = function () {
    // this.animate();
    utils_1.WindowEvents.addResizeCallback(this.updateSize);
    utils_1.WindowEvents.addVisibilityCallback(this.handleVisibilityChange, [this.uuid], utils_1.WindowEvents.Visibility.FULLY_VISIBLE);
  };

  CircleDiagram.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeResizeCallback(this.updateSize);
    utils_1.WindowEvents.removeVisibilityCallback(this.handleVisibilityChange);
  };

  CircleDiagram.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        valueLabel = _a.valueLabel,
        label = _a.label,
        amount = _a.amount;
    var size = Math.max(200, Math.min(480, this.state.size));
    var cssAnimationStarted = this.state.animationStarted && canAnimateSvg;
    var currentValueLabel = this.state.animationStarted ? this.state.animationLabel || valueLabel : '';
    var currentAmount = this.state.animationStarted ? amount : 0;

    if (!canAnimateSvg) {
      // We need to animate for ourselfs (e.g. IE11)
      currentAmount *= Math.min(this.state.animationAmount || 0, 1.0);
    }

    return React.createElement('div', {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + 'circlediagram', className]),
      ref: function ref(el) {
        return _this.elementRef = el;
      }
    }, React.createElement('div', {
      className: CSSPrefix_1.lsgPre + 'circlediagram-inner'
    }, (valueLabel || label) && React.createElement('div', {
      className: CSSPrefix_1.lsgPre + 'circlediagram-heading'
    }, React.createElement('div', {
      className: CSSPrefix_1.lsgPre + 'circlediagram-heading-value'
    }, currentValueLabel), React.createElement('div', {
      className: CSSPrefix_1.lsgPre + 'circlediagram-heading-label'
    }, label)), React.createElement('svg', {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + 'circlediagram-chart']),
      viewBox: '0 0 ' + size + ' ' + size,
      preserveAspectRatio: 'none'
    }, React.createElement('circle', {
      cx: '50%',
      cy: '50%',
      r: size * 0.5 - 6,
      fill: 'transparent',
      className: CSSPrefix_1.lsgPre + 'circlediagram-chart-track',
      stroke: '#ffcc33'
    }), React.createElement('circle', {
      cx: '50%',
      cy: '50%',
      r: size * 0.5 - 6,
      strokeDashoffset: Math.PI * 100 * (1.0 - currentAmount) + '%',
      fill: 'transparent',
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + 'circlediagram-chart-pie', cssAnimationStarted && CSSPrefix_1.lsgPre + 'circlediagram-chart-pie__animate']),
      stroke: '#ffcc33'
    }))));
  };

  CircleDiagram.animationDuration = 1;
  return CircleDiagram;
}(React.Component);

exports.CircleDiagram = CircleDiagram;